import _ from "lodash";
import topicOption from "./topicOption"
const HelpMore = {
    template: ` <h3>${langhelp.help.title}</h3>
                <template v-if="errors" v-for="(err,index) in errors" :key="index">
                    <template v-for="(msg,index) in err" :key="index">
                        <p v-text="msg" class="alert alert-danger" role="alert"></p>
                    </template>
                </template>
                <div class="pure-g">
                    <h3 class="pure-u-1 pure-u-md-2-5 fs-6 mt-0" v-if="!this.orderId">Email</h3>
                   <div class="pure-u-1 pure-u-md-3-5 mb-4" v-if="!this.orderId">
                        <div class="form-group m-0">
                            <input v-model="inputs.email" id="email" type="email">
                        </div>
                    </div>
                    <h3 class="pure-u-1 pure-u-md-2-5 fs-6 mt-0">${langhelp.help.type}</h3>
                    <div class="pure-u-1 pure-u-md-3-5 mb-4">
                        <select v-model="inputs.contact_category_id"  class="w-100">
                            <template v-for="(topic,i) in topics" :key="i">
                                <topic-option
                                    :translations="topic.contactCategoryTranslations"
                                    :value="topic.id"
                                    />
                            </template>
                        </select>
                    </div>
                    <template v-for="f in fields" :key="f.key">
                        <h3 class="pure-u-1 pure-u-md-2-5 fs-6 mt-0">{{ label(f) }}<span v-if="f.required"> *</span></h3>
                        <div class="pure-u-1 pure-u-md-3-5 mb-4">
                            <input v-if="f.display==='text'" v-model="inputs.fields[f.key]" type="text" maxlength="500" class="w-100">
                            <input v-else-if="f.display==='number'" v-model="inputs.fields[f.key]" type="number" step="any" class="w-100">
                            <input v-else-if="f.display==='date'" v-model="inputs.fields[f.key]" type="date" class="w-100">
                            <select v-else-if="f.display==='select'" v-model="inputs.fields[f.key]" class="w-100">
                                <option value=""></option>
                                <option v-for="o in f.options" :key="o.value" :value="o.value">{{ optionLabel(o) }}</option>
                            </select>
                            <div v-else>
                                <label v-for="o in f.options" :key="o.value" class="d-block">
                                    <input type="checkbox" :checked="inputs.fields[f.key]===o.value"
                                        @change="inputs.fields[f.key]=$event.target.checked?o.value:''">
                                    {{ optionLabel(o) }}
                                </label>
                            </div>
                        </div>
                    </template>
                    <h3 class="pure-u-1 pure-u-md-2-5 fs-6 mt-0">${langhelp.help.description}</h3>
                    <div class="pure-u-1 pure-u-md-3-5 mb-4">
                       <textarea v-model="inputs.text" class="w-100"></textarea>
                    </div>
                    <template v-if="topic && topic.allow_files">
                        <h3 class="pure-u-1 pure-u-md-2-5 fs-6 mt-0">${langhelp.help.attach}</h3>
                        <div class="pure-u-1 pure-u-md-3-5 mb-4">
                            <input type="file" multiple @change="pickFiles">
                            <small class="d-block">${langhelp.help.attach_hint}</small>
                        </div>
                    </template>
                    <div class="pure-u-1 text-end mb-4">
                        <button class="btn btn-primary" @click="handleSubmit"  :class="{'loading-spin':loading}" :disabled="loading"><span>${langhelp.help.send}</span></button>
                    </div>
                </div>`,
    props:['type','order-id'],
    components:{topicOption},
    data() {
        return {
            loading: false,
            inputs:{
                contact_category_id:"",
                text:"",
                email:"",
                fields:{}
            },
            files:[],
            topics: [],
            errors:[]
        };
    },
    computed:{
        topic(){
            return this.topics.find(t=>t.id===this.inputs.contact_category_id) || null;
        },
        // the extra form elements of the chosen topic
        fields(){
            return this.topic && this.topic.fields ? this.topic.fields : [];
        },
        configType(){
             if(this.type==='compliment') return 2;
             if(this.type==='normal') return 1;

             return null;
        }
    },
    watch: {
        // another topic has other elements: the earlier answers and files do not carry over
        'inputs.contact_category_id'(){
            this.inputs.fields={};
            this.files=[];
        },
        inputs: {
            handler(val) {
                if (this.errors.length) this.errors = [];
            },
            deep: true,
        },
    },
    mounted(){
        forms.load();

        this.fetchContactTypes();
    },
    methods:{
       async fetchContactTypes(){
            const response=await fetch(`/api/contact-categories`,{
                method:"POST",
                headers:http.headers(),
                body:JSON.stringify({token: Cookies.getItem('login_token'),type:this.configType})
              }
            )
            if(response.ok){
                const categories=await response.json();
                this.topics=categories.data;
                this.inputs.contact_category_id=categories.data[0].id
            }
        },
        async handleSubmit(){
           this.loading = true;
            // multipart: the files travel with the message
            const body=new FormData();
            body.append('token',Cookies.getItem('login_token') || '');
            body.append('order_id',this.orderId);
            body.append('contact_category_id',this.inputs.contact_category_id);
            body.append('text',this.inputs.text);
            if(this.inputs.email) body.append('email',this.inputs.email);
            if(this.fields.length) body.append('fields',JSON.stringify(this.inputs.fields));
            this.files.forEach(f=>body.append('files[]',f));
            const headers=http.headers();
            delete headers['Content-Type'];
            const response=await fetch(`/api/contact`,{method:"POST",headers,body})
            const contact=await response.json();
            AppEvents.callEvent("CONTACT", {});
            this.loading = false;
            if(response.ok){
                this.resetForm();
                this.$emit('success');
                return;
            }
            this.errors=contact.errors;

        },
        label(f){
            const l=f.labels||{};
            return l[window.lan] || l.en || Object.values(l)[0] || f.key;
        },
        optionLabel(o){
            const l=o.labels||{};
            return l[window.lan] || l.en || Object.values(l)[0] || o.value;
        },
        pickFiles(e){
            this.files=Array.from(e.target.files).slice(0,3);
        },
        resetForm(){
            this.inputs.text="";
            this.inputs.fields={};
            this.files=[];
        }
    }
};
export default HelpMore;
